import React from 'react';
import Chip from '@mui/material/Chip';

/**
 * Drop-in replacement for MUI's `Chip` with a softer, pastel look: a tinted
 * background + the same hue for the text, instead of the default solid fill
 * + white text. Only affects filled, colored chips — `variant="outlined"`
 * and `color="default"` (or no color) render exactly like a plain `Chip`.
 */
export default function SoftChip({ color, variant = 'filled', sx, ...props }) {
  if (variant !== 'filled' || !color || color === 'default') {
    return <Chip color={color} variant={variant} sx={sx} {...props} />;
  }

  return (
    <Chip
      color={color}
      variant={variant}
      sx={[
        (theme) => {
          const paletteColor = (theme.vars || theme).palette[color];
          // Texto no tom escuro da cor (no dark, no claro, para manter o contraste).
          const textColor = paletteColor.dark ?? paletteColor.main;
          const darkTextColor = paletteColor.light ?? paletteColor.main;
          return {
            backgroundColor: theme.alpha(paletteColor.main, 0.14),
            color: textColor,
            '& .MuiChip-deleteIcon': {
              color: theme.alpha(textColor, 0.7),
              '&:hover': { color: textColor },
            },
            ...theme.applyStyles('dark', {
              color: darkTextColor,
              '& .MuiChip-deleteIcon': {
                color: theme.alpha(darkTextColor, 0.7),
                '&:hover': { color: darkTextColor },
              },
            }),
          };
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...props}
    />
  );
}
